import React from 'react';
import { NotificationItem } from './NotificationItem';
import styles from './Notifications.module.scss';
import { Notification } from './types';

export const Notifications: React.FC<Props> = ({
  removeNotification,
  notifications,
}) => {
  return (
    <div className={styles.notifications}>
      {notifications.map((notification, index) => {
        return (
          <NotificationItem
            key={notification.id}
            notification={notification}
            hide={() => removeNotification(notification)}
            messageType={notification.messageType}
            index={index}
          />
        );
      })}
    </div>
  );
};

type Props = {
  removeNotification: (notification: Notification) => void;
  notifications: Notification[];
};
